import type { EnemyData } from '../enemyData';

export type DeathCauseApi =
  | 'pterodactyl'
  | 'cactus_small_single'
  | 'cactus_small_double'
  | 'cactus_small_triple'
  | 'cactus_large_single'
  | 'cactus_large_double'
  | 'cactus_large_triple'
  | 'cactus_mixed';

export function deathCauseFromEnemy(data: EnemyData): DeathCauseApi {
  if (data.canFly) return 'pterodactyl';
  switch (data.cactusType) {
    case 'smallSingle':
      return 'cactus_small_single';
    case 'smallDouble':
      return 'cactus_small_double';
    case 'smallTriple':
      return 'cactus_small_triple';
    case 'largeSingle':
      return 'cactus_large_single';
    case 'largeDouble':
      return 'cactus_large_double';
    case 'largeTriple':
      return 'cactus_large_triple';
    case 'mixed':
      return 'cactus_mixed';
    default:
      return 'cactus_small_single';
  }
}
